<template>

    <vxe-modal v-model="showQR" width="320px" transfer>
      <template #title>
        <span>小程序码</span>
      </template>
      <template #default>
        <div class="info">
          <div class="into-content">
            <img src="@/assets/images/questionCode.png" alt />
            <span>{{ title }}</span>
            <div class="content-btn" @click="download">
              <span>立即下载</span>
              <i class="custom-icon iconfont icon-xiazai"></i>
            </div>
          </div>
          <div class="info-bton">
            <el-image
              class="img"
              :src="imgUrl"
              :preview-src-list="[imgUrl]"
              :initial-index="4"
              fit="cover"
            />
            <span class="bton-tilte"
              >识别小程序二维码 <br />进入铁安通工伤平台查看问卷</span
            >
          </div>
        </div>
      </template>
    </vxe-modal>

</template>
<script>
import { createWXQRCode } from "@api/ApiCreateWeiXinQRCode";
export default {
  data() {
    return {
      imgUrl: "",
      showQR: false,
      title: "",
    };
  },
  methods: {
    getQRCode(path, title, query, width) {
      let _this = this;
      let target = path;
      if (query) {
        for (let item in query) {
          if (target.includes("?")) {
            target = target + "&";
          } else {
            target = target + "?";
          }
          target = target + `${item}=${query[item]}`;
        }
      }
      createWXQRCode(target, width)
        .then((res) => {
          _this.imgUrl = res.data;
          _this.title = title;
          _this.showQR = true;
        })
        .catch((message) => {
          _this.$message.error(message);
        });
    },
    download() {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = this.imgUrl;
      link.setAttribute("download", this.title + ".jpg");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
.info {
  display: flex;
  flex-direction: column;

  .into-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 200px;
    img {
      width: 72px;
    }
    > span:first-of-type {
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 22px;
      text-align: center;
      padding: 5px 10px;
      display: inline-block;
    }

    .content-btn {
      cursor: pointer;
      width: 134px;
      height: 36px;
      text-align: center;
      border-radius: 25px 25px 25px 25px;
      background-color: #0747a6;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      > span:first-of-type {
        display: inline-block;
        margin-right: 9px;
      }
    }
  }
  .info-bton {
    display: flex;
    height: 130px;
    background-color: #f7f7f8;
    border-radius: 0px 0px 0px 0px;
    align-items: center;
    padding: 10px 10px;
    box-sizing: border-box;
    .img {
      width: 100px;
      vertical-align: middle;
      margin-right: 6px;
      background-color: rgba(#f7f7f8, 0);
    }
    .bton-tilte {
      display: inline-block;
      width: 168px;
      height: 44px;
      font-size: 14px;
      a {
        color: #0747a6;
        font-size: 14px;
      }
    }
  }
}
.custom-btn {
  width: 73px;
  max-height: 32px;
  min-height: 32px;
  background: #0747a6;
  border-radius: 2px 2px 2px 2px;
  font-size: 14px;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  padding: 0;
  border: 0;
  .custom-icon {
    font-size: 18px;
    vertical-align: text-bottom;
  }
}
.container {
  box-sizing: border-box;

  &-content {
    height: 150px;
  }

  &-bottom {
    &-qrcode {
      width: 100px;
      height: 100px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
